import React, { useState, useEffect } from 'react'

import {
	Button,
	Checkbox,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	FormControl,
	FormHelperText,
	InputAdornment,
	InputLabel,
	ListItemText,
	MenuItem,
	IconButton,
	Icon,
	Select,
	Snackbar,
	TextField,
	CircularProgress,
	Typography
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { useSelector, useDispatch } from 'react-redux'

import { DeletableChip } from '../../components/Misc/DeletableChip'

import { CustomAddOnOccurences } from '../Addons/customAddonOccurences'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'

import MuiAlert from '@material-ui/lab/Alert'

import { postAddOns } from '../../actions/addons/addons.actions'

const facilityTypes = [
	'dailyPets',
	'addOns',
	'checkIn',
	'firstBarCheckIn',
	'barCheckInTimes',
	'barRoster'
	// "householdData",
	// "vaccineExpiration",
]

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		// flexWrap: "wrap",
		margin: '16px 0px 24px 0px'
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '7px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		marginBottom: 16,
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		}
	}
}))

const DataDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const [isStartDateOpen, setIsStartDateOpen] = useState(false)
	const [startDate, updateStartDate] = useState(null)

	const [isEndDateOpen, setIsEndDateOpen] = useState(false)
	const [endDate, updateEndDate] = useState(null)
	const [facility, setFacility] = useState('')
	const { isShown, setIsShown, runExport, loading, type, facilities, noDates } = props
	useEffect(() => {
		if (facilities && facilities.length && !facility && facilityTypes.includes(type)) {
			let fac = facilities.find((s) => s.skiptown)
			if (fac) setFacility(fac._id)
		}
	}, [facilities, type])
	const getType = () => {
		switch (type) {
			case 'barRoster':
				return 'Private Bar Member Roster'
				break
			case 'householdData':
				return 'Household Data Report'
				break
			case 'vaccineExpiration':
				return 'Vaccine Expiration Dates Report'
				break
			case 'membershipStatuses':
				return 'Membership Statuses Report'
				break
			case 'barCheckInTimes':
				return 'Bar Check-In Times Report'
				break
			case 'firstBarCheckIn':
				return 'First Time Bar Visitors Report'
				break
			case 'checkIn':
				return 'Pet Care Pick-up & Drop-off Times Report'
				break
			case 'addOns':
				return 'Enrichments'
				break
			case 'dailyPets':
				return 'Daily Pets'
				break
			case 'boardingExport':
				return 'Boarding Revenue Export'
				break
			case 'daycareExport':
				return 'Daycare Revenue Export'
				break
			case 'dogWalkingExport':
				return 'Home Services Export'
				break
			default:
				break
		}
	}

	return (
		<Dialog
			open={isShown}
			onClose={() => setIsShown()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle>PREPARE EXPORT</DialogTitle>
			<div
				style={{
					backgroundColor: '#F9F9F9',
					width: '100%',
					borderRadius: 6,
					padding: 16,
					marginTop: 8
				}}>
				<Typography variant="body1" style={{ color: '#4D4C4F', fontSize: 14, fontWeight: 'bold' }}>
					{getType()}
				</Typography>
			</div>
			<DialogContent>
				<div className={classes.formWrapper}>
					{!noDates && (
						<KeyboardDatePicker
							disableToolbar
							style={{
								minWidth: '400px',
								margin: 0,
								marginBottom: 16
							}}
							InputAdornmentProps={{
								position: 'start',
								component: () => (
									<IconButton onClick={() => setIsStartDateOpen(true)}>
										<Icon
											className="far fa-calendar-alt"
											style={{
												fontSize: '1.325rem'
											}}
										/>
									</IconButton>
								)
							}}
							open={isStartDateOpen}
							onOpen={() => setIsStartDateOpen(true)}
							onClose={() => setIsStartDateOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							id="start-date"
							label="Start Date"
							inputVariant="filled"
							value={startDate}
							onChange={updateStartDate}
							className={classes.datePicker}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'Start Date',
								className: classes.calendarButton
							}}
						/>
					)}
					{!noDates && (
						<KeyboardDatePicker
							disableToolbar
							style={{
								minWidth: '400px',
								margin: 0
							}}
							InputAdornmentProps={{
								position: 'start',
								component: () => (
									<IconButton onClick={() => setIsEndDateOpen(true)}>
										<Icon
											className="far fa-calendar-alt"
											style={{
												fontSize: '1.325rem'
											}}
										/>
									</IconButton>
								)
							}}
							open={isEndDateOpen}
							onOpen={() => setIsEndDateOpen(true)}
							onClose={() => setIsEndDateOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							id="end-date"
							label="End Date"
							inputVariant="filled"
							value={endDate}
							onChange={updateEndDate}
							className={classes.datePicker}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'End Date',
								className: classes.calendarButton
							}}
						/>
					)}
					{facilityTypes.includes(type) ? (
						<TextField
							label={`Facility`}
							variant="filled"
							select
							className={classes.vaccineField}
							value={facility}
							style={{ marginTop: noDates ? 0 : 16 }}
							onChange={(e) => setFacility(e.target.value)}>
							{facilities.map((f) => {
								return <MenuItem value={f._id}>{f.name}</MenuItem>
							})}
						</TextField>
					) : null}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => runExport({ startDate, endDate, facility })}
					color="secondary"
					disabled={loading}>
					{loading ? <CircularProgress /> : 'EXPORT'}
				</Button>
				<Button
					variant="outlined"
					style={{
						color: '#6B4AD6',
						borderColor: '#6B4AD6'
					}}
					onClick={() => setIsShown()}>
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default DataDialog
